import {useEffect, useState} from "react";
import {FaBook} from "react-icons/fa";
import RichTextInput from "../../../../components/RichTextInput/RichTextInput";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";

export default function NoteBookSection({className, show, defaultContent, id, ...props}) {
    const [showEditor, setShowEditor] = useState(false);
    const [form, error, loading, setFormData, actions] = useForm({

        note: ""
    })

    const content = form?.note
    const setContent = (e) => {
        setFormData({
            note: e
        })
    }

    function saveNote() {
        setShowEditor(!showEditor)
        console.log("Saving note", form,id)
        actions.post(URLS.notes,(data)=>{
            return {
                question: id,
                questionId: id,
                ...data,
            }
        }).then(response => {
            setFormData(response?.data?.data)
        })
    }

    useEffect(() => {
        actions.get(URLS.notes,(data)=>{
            return {
                question: id,
                ...data,
            }
        }).then(response => {
            setFormData(response?.data?.data)
        })
    }, []);

    return (
        <div
            className={`${show ? "flex" : "hidden"} relative overflow-y-hidden h-[260px] max-h-[240px]  mb-20 mt-2  border-[1px] rounded-md w-full flex flex-col gap-2 ${className}`}>
            {!content && !showEditor && <div className={"flex m-auto flex-row justify-center items-center w-full "}>
                <div onClick={() => setShowEditor(!showEditor)}
                     className={"flex cursor-pointer text-secondary-900 flex-row justify-center items-center gap-2"}>
                    <FaBook/>
                    <p className={"text-lg font-bold "}>
                        New note
                    </p>

                </div>
            </div>}

            {
                showEditor && <div className={"top-0"}>
                    <RichTextInput
                        style={{
                            height: "200px"
                        }}
                        value={content} onChange={setContent}/>
                </div>
            }

            {
                content && !showEditor && <div className={"flex  flex-col gap-2 px-4 py-2 "}>
                    <div className={"flex sticky  top-1 flex-row justify-between items-center"}>
                        <p className={"text-lg font-bold "}>
                            Note
                        </p>
                        <div onClick={() => setShowEditor(!showEditor)}
                             className={"flex cursor-pointer text-secondary-900 flex-row justify-center items-center gap-2"}>
                            <FaBook/>
                            <p className={"text-lg font-bold "}>
                                Edit
                            </p>
                        </div>
                    </div>
                    <div dangerouslySetInnerHTML={{
                        __html: content
                    }} className={"text-sm overflow-clip mt-4  max-h-[220px]"}/>

                </div>
            }
            {
                showEditor &&
                <div className={"flex absolute  right-0 bottom-0 flex-row justify-end items-center px-4 py-2"}>
                    <div onClick={() => saveNote()}
                         className={"flex cursor-pointer text-white rounded-md px-4 py-1 bg-secondary-900 flex-row justify-center items-center gap-2"}>
                        <p className={"text-lg  "}>
                            Save
                        </p>
                    </div>
                </div>
            }
        </div>

    )
}